import { EyeIcon, PresentationFillIcon } from "@vericus/cadmus-icons";
import { Button, Text } from "@vericus/cadmus-ui";

import { useParams } from "react-router-dom";

import {
  AssessmentFragment,
  useAssessmentQuery,
  useWorkGroupQuery,
} from "@/generated/graphql";
import { useRootNavigate } from "@/routes";
import { formatDateFull } from "@/utils/datetime";

import { GroupCard } from "./group-card";
import { GroupCharterCard } from "./group-charter-card";
import * as styles from "./home-page.css";

export function Preparation() {
  const { assessmentId = "" } = useParams();
  const { data: assessmentData } = useAssessmentQuery({
    variables: { assessmentId },
  });
  const { data: workGroupData } = useWorkGroupQuery({
    variables: { assessmentId },
  });

  const assessment = assessmentData?.assessment;
  const workGroup = workGroupData?.studentWorkGroup;
  const group = workGroup?.group;

  if (!assessment) {
    return null;
  }

  const showCharter = assessment.settings?.groupCharterEnabled ?? false;
  return (
    <>
      <div className={styles.verticalLine} />
      <GroupCard
        assessment={assessment}
        workGroupId={workGroup?.id}
        userGroup={group ?? null}
        finalised={workGroup?.finalised ?? false}
        changeRequested={workGroup?.latestGroupChangeRequest}
      />
      {group && showCharter && (
        <GroupCharterCard
          groupId={group.id}
          charter={workGroup?.charter}
          finalised={workGroup?.finalised}
          dueDate={assessment.settings?.groupCharterDueDate}
        />
      )}
      <InstructionCard assessment={assessment} />
    </>
  );
}

interface InstructionProps {
  assessment: AssessmentFragment;
}

function InstructionCard(props: InstructionProps) {
  const { assessment } = props;
  const rootNavigate = useRootNavigate();

  return (
    <div className={styles.steps}>
      <div className={styles.stepIcon["initial"]}>
        <PresentationFillIcon label="" size={30} />
      </div>
      <div className={styles.stepCard}>
        <Text kind="headingFour">Instructions</Text>
        <Text kind="bodyLine">
          Instructions for completing your report are available here.
        </Text>
        <div className={styles.instructionSheet}>
          <div>
            <Text kind="headingFive" textTransform="capitalize">
              Group Work: {assessment.name}
            </Text>
            {assessment.settings?.dueDate && (
              <Text kind="bodySm">
                <strong>Due:</strong>{" "}
                {formatDateFull(new Date(assessment.settings.dueDate))}
              </Text>
            )}
          </div>
          <Button
            kind="secondary"
            icon={<EyeIcon label="" size={24} />}
            onClick={() => rootNavigate("/instructions/group")}
          >
            View Instructions
          </Button>
        </div>
        {assessment.settings?.individualReportEnabled && (
          <div className={styles.instructionSheet}>
            <div>
              <Text kind="headingFive">Individual Work</Text>
              {assessment.settings?.individualReportDueDate && (
                <Text kind="bodySm">
                  <strong>Due:</strong>{" "}
                  {formatDateFull(
                    new Date(assessment.settings.individualReportDueDate)
                  )}
                </Text>
              )}
            </div>
            <Button
              kind="secondary"
              icon={<EyeIcon label="" size={24} />}
              onClick={() => rootNavigate("/instructions/individual")}
            >
              View Instructions
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
